import { createSelector } from 'reselect';
import { statComparisonSelector } from './simple-selectors';

export const statComparisonRequestsSelector = createSelector(
    statComparisonSelector,
    (statComparison) => statComparison.requests
);
